export function normalizeVisibility(visible: any, fallback: boolean): boolean {
  if (typeof visible === 'boolean') {
    return visible;
  }

  if (typeof visible === 'string') {
    return visible.toLowerCase() === 'true';
  }

  if (visible === undefined || visible === null) {
    return fallback;
  }

  return Boolean(visible);
}
